<template>
  <section class="card-pricing p-4 justify-content-center">

    <img src="https://picsum.photos/80/80" class="rounded-circle rounded" >
    <h3 class="mt-4 mb-4">طراحی ساده</h3>
    <h2 class="font-weight-bolder mb-4">توسعه دهنده وب</h2>
    <h3 class="primary-color mb-4">قیمت 89 هزارتومان</h3>
    <p class="mt-4">طراحی اختصاصی کامپوننت </p>
    <p>صفحات آماده و دمو</p>
    <p>پشتیبانی مادام العمر</p>
    <p class="mb-5">آپدیت رایگان ماهانه</p>
    <m-bt400 class="rounded-pill">شروع کنید</m-bt400>
  </section>
</template>

<script>
export default {
  name: "C33",
  data() {
  },
  props: ['icon']
}
</script>

<style scoped>

.card-pricing{
  text-align: center;
  border-radius: 40px;
}
.card-pricing:hover{
  transition: all 0.3s ease-out 0s;
  background: var(--primary);


}
</style>